import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

// El taller compartido: estado del servidor (sin contraseñas), probar la conexión y conectar los proyectos pendientes.
export function useWorkshopStatus(enabled = true) {
  return useQuery({
    queryKey: ["workshop-status"],
    queryFn: async () => (await apiClient.get("/workshop/status")).data,
    enabled,
    retry: false,
  });
}

export function useTestWorkshop() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => (await apiClient.post("/workshop/test")).data,
    onSuccess: (data) => queryClient.setQueryData(["workshop-status"], data.status),
  });
}

export function useSyncWorkshop() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => (await apiClient.post("/workshop/sync")).data,
    onSuccess: (data) => queryClient.setQueryData(["workshop-status"], data.status),
  });
}

export function useConnectWorkshop() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ host, port, username, password }) => (await apiClient.post("/workshop/connect", { host, port, username, password })).data,
    onSuccess: (data) => queryClient.setQueryData(["workshop-status"], data.status),
  });
}

// Preparación del servidor del taller: avance en vivo (se consulta cada 3 s mientras corre) y revisión de solo lectura.
export function usePrepareState(enabled = true) {
  return useQuery({
    queryKey: ["workshop-prepare"],
    queryFn: async () => (await apiClient.get("/workshop/prepare/status")).data,
    enabled,
    retry: false,
    refetchInterval: (query) => (query.state.data?.status === "running" ? 3000 : false),
  });
}

export function useStartPrepare() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => (await apiClient.post("/workshop/prepare/start")).data,
    onSuccess: (data) => queryClient.setQueryData(["workshop-prepare"], data),
  });
}

export function useCheckWorkshop() {
  return useMutation({ mutationFn: async () => (await apiClient.post("/workshop/check")).data });
}
